
import Vue from 'vue'
import api from 'Api'
import { uuid } from 'vue-uuid'

const URL = '/command'

const state = {
  commands: [],
  activeCommand: {}
}

const status = {
  commandsLoading: false
}

const getters = {
  commands: state => {
    return state.commands
  },
  activeCommand: state => {
    return state.activeCommand
  }
}

function get (context, URL, handler) {
  return api().get(URL).then(response => handler(context, response))
}

function post (context, URL, data, handler) {
  return api().post(URL, data).then(response => handler(context, response))
}

function put (context, data, handler) {
  return api().put(URL, data).then(response => handler(context, response))
}

function apiDelete (context, URL, id, handler) {
  return api().delete(URL + '/' + id).then(response => handler(context, id, response))
}

function handleCommandLoad (context, response) {
  const commands = response.data
  status.commandsLoading = false
  if (commands.error) {
    context.commit('apiError', commands.error)
  } else {
    context.commit('commandsLoaded', commands)
  }
}

function handleCommandSave (context, response) {
  const command = response.data
  if (command.error) {
    context.commit('apiError', command.error)
  } else {
    context.commit('commandSuccess', command)
  }
}

function handleCommandDelete (context, id, response) {
  const command = response.data
  if (command.error) {
    context.commit('apiError', command.error)
  } else {
    context.commit('commandDeleted', id)
  }
}

function handleGetCommand (context, response) {
  const command = response.data
  if (command.error) {
    context.commit('apiError', command.error)
  } else {
    context.commit('setActiveCommand', command)
  }
}

// function addIfPresent (source, destination, propertyName) {
//   if (source[propertyName]) {
//     destination[propertyName] = source[propertyName]
//   }
// }

function replaceCommand (state, command) {
  state.commands = state.commands.filter(item => item.entity_id !== command.entity_id)
  state.commands.push(command)
  return state.commands
}

const actions = {
  loadCommands (context, payload) {
    if (status.commandsLoading) {
      return
    }
    if (payload) {
      status.commandsLoading = true
      get(context, URL + '/collector/' + String(payload), handleCommandLoad)
    }
  },

  postCommand (context, payload) {
    const commandData = {
      type: payload.type,
      data: payload.data,
      collector_id: payload.collector_id,
      organization_id: payload.organization_id,
      status: payload.status
    }

    let req
    if (payload.entity_id) {
      req = put(context, commandData, handleCommandSave)
    } else {
      commandData.entity_id = uuid.v4()
      req = post(context, URL, commandData, handleCommandSave)
    }
    context.commit('updateCommandData', commandData)
    return req
  },

  saveCommand (context, payload) {
    const commandData = {
      version: payload.version,
      entity_id: payload.entity_id,
      type: payload.type,
      data: payload.data,
      collector_id: payload.collector_id,
      organization_id: payload.organization_id,
      status: payload.status
    }
    let req
    if (payload.entity_id) {
      req = put(context, commandData, handleCommandSave)
    } else {
      commandData.entity_id = uuid.v4()
      req = post(context, URL, commandData, handleCommandSave)
    }
    context.commit('updateCommandData', commandData)
    return req
  },
  deleteCommand (context, id) {
    state.commands = state.commands.filter(command => command.entity_id !== id)
    return apiDelete(context, URL, id, handleCommandDelete)
  },
  getCommand (context, id) {
    const commandArr = state.commands.filter(item => item.entity_id === id)
    if (commandArr && commandArr[0]) {
      context.commit('setActiveCommand', commandArr[0])
    }
    get(context, URL + '/' + id, handleGetCommand)
  }
}

const mutations = {
  commandsLoaded (state, commands) {
    state.commands = commands
  },
  commandSuccess (state, command) {
    state.commands = replaceCommand(state, command)
    Vue.notify({
      group: 'loggedIn',
      type: 'success',
      text: 'Command Saved'
    })
  },
  commandDeleted (state, id) {
    state.commands = state.commands.filter(command => command.entity_id !== id)
    Vue.notify({
      group: 'loggedIn',
      type: 'success',
      text: 'Command deleted'
    })
  },
  setActiveCommand (state, command) {
    state.activeCommand = command
  },
  updateCommandData (state, command) {
    state.commands = replaceCommand(state, command)
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
  name: 'commandCommand'
}
